import { getLatestPushbackRecord, getSubmissionGradeSnapshot, getSubmissionLmsSyncStatus } from 'utils/gradePushback';

export const SubmissionFilter = Object.freeze({
    READY: 'ready',
    REVIEWED: 'reviewed',
    SYNCED: 'synced',
    NEEDS_ATTENTION: 'needs_attention',
    TIMELYGRADER_GRADE: 'timelygrader_grade',
    LMS_PUSHED_GRADE: 'lms_pushed_grade',
});

export const filterSubmissions = (submissions, filters, assignment) => {
    const search = `${filters.search || ''}`.toLowerCase();
    const statusFilters = filters.status || [];
    const lmsSyncStatusFilters = filters.lmsSyncStatus || [];
    const gradeRecordFilters = filters.gradeRecord || [];

    return submissions.filter((submission) => {
        const matchesSearch =
            submission.files?.some(({ name }) => `${name || ''}`.toLowerCase().includes(search)) ||
            `${submission.api?.user?.name || ''}`.toLowerCase().includes(search) ||
            `${submission.api?.user?.id || ''}`.toLowerCase().includes(search);

        const matchesStatus =
            !statusFilters.length ||
            statusFilters.some((status) => {
                if (status === SubmissionFilter.READY) return submission.ai && !submission.grading;
                if (status === SubmissionFilter.REVIEWED) return Boolean(submission.grading);
                return false;
            });

        const syncStatus = getSubmissionLmsSyncStatus(submission, assignment);
        const matchesLmsSyncStatus =
            !lmsSyncStatusFilters.length || lmsSyncStatusFilters.includes(syncStatus);

        const matchesGradeRecord =
            !gradeRecordFilters.length ||
            gradeRecordFilters.some((record) => {
                if (record === SubmissionFilter.TIMELYGRADER_GRADE) {
                    return Boolean(getSubmissionGradeSnapshot(submission, assignment));
                }
                if (record === SubmissionFilter.LMS_PUSHED_GRADE) {
                    return Boolean(getLatestPushbackRecord(submission));
                }
                return false;
            });

        return matchesSearch && matchesStatus && matchesLmsSyncStatus && matchesGradeRecord;
    });
};
